import styled, { css } from "styled-components"
import { parseUIPercents, parseUIPercentsMobile } from "../../utils"

export const Footer = styled.footer`
  border-top: 1px solid #001c31;
  height: 84px;
  padding-top: 36px;
  position: relative;
  @media (max-width: 768px) {
    height: 134px;
    padding-top: 12px;
    text-align: center;
  }
`

const linkShared = css`
  width: ${parseUIPercents(24)};
  position: absolute;
  top: ${parseUIPercents(32)};
  cursor: pointer;
  @media (max-width: 768px) {
    width: ${parseUIPercentsMobile(24)};
    top: ${parseUIPercentsMobile(80)};
  }
`

export const DribbleLink = styled.div`
  ${linkShared};
  right: ${parseUIPercents(318)};
  @media (max-width: 768px) {
    left: ${parseUIPercentsMobile(87)};
  }
`
export const BehanceLink = styled.div`
  ${linkShared};
  right: ${parseUIPercents(286)};
  @media (max-width: 768px) {
    left: ${parseUIPercentsMobile(131)};
  }
`
export const MediumLink = styled.div`
  ${linkShared};
  right: ${parseUIPercents(254)};
  @media (max-width: 768px) {
    left: ${parseUIPercentsMobile(175)};
  }
`
export const LinkedLink = styled.div`
  ${linkShared};
  right: ${parseUIPercents(222)};
  @media (max-width: 768px) {
    left: ${parseUIPercentsMobile(219)};
  }
`
export const InstagramLink = styled.div`
  ${linkShared};
  right: ${parseUIPercents(193)};
  @media (max-width: 768px) {
    left: ${parseUIPercentsMobile(263)};
  }
`
